export function getScreenSize() {
  if (window.screen) {
    const { width, height } = window.screen;
    return { width, height };
  }
  return {
    height: window.innerHeight,
    width: window.innerWidth
  };
}
